import { BookForm, Footer, Header, HeroSlider, ScrollToTop } from "./components";
import { Outlet, useLocation } from "react-router-dom";

export default function App({data}) {
  const location = useLocation();

  const isRoomDetailsPage =
    location.hash.startsWith("#room-");

  return (
    <main>
      {!isRoomDetailsPage && 
     <>
      <Header data={data}/>
       <ScrollToTop />
      <HeroSlider />
      <div className="container mx-auto max-w-7xl relative">
        <div className="bg-accent/20 mt-4 p-4 lg:absolute lg:left-0 lg:right-0 lg:p-0 lg:-top-12 lg:z-30 lg:shadow-xl">
          <BookForm />
        </div>
      </div>
     </>
      }

      <Outlet />

      {!isRoomDetailsPage && <Footer />}
    </main>
  );
}